import {getSocket} from "../../../../sockets";
import ss from "socket.io-stream";
import MAYA from "../../../../maya_api";

export default async function scanImages(frontImage, backImage) {
  if (!(frontImage && backImage)) return null;

  const socket = getSocket();

  const frontImageBlobObject = await fetch(frontImage);
  const frontImageBlob = await frontImageBlobObject.blob();

  const backImageBlobObject = await fetch(backImage);
  const backImageBlob = await backImageBlobObject.blob();

  const encodedSession = await MAYA.getEncodedSession();

  let frontImageStream = ss.createStream();
  let backImageStream = ss.createStream();

  ss(socket).emit('/h/ss/files', '/h/check_reader/scan', {
    device_guid: encodedSession.device_guid,
    server_data: encodedSession.encoded_session_data,
    type: 'check_reader',
    images: {
      front: {
        size: frontImageBlob.size,
        format: 'png',
        width: 0,
        height: 0
      },
      back: {
        size: backImageBlob.size,
        format: 'png',
        width: 0,
        height: 0
      }
    }
  }, [frontImageStream, backImageStream]);

  ss.createBlobReadStream(frontImageBlob).pipe(frontImageStream);
  ss.createBlobReadStream(backImageBlob).pipe(backImageStream);
}


// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/modules/scanImages.js